import React from "react";
import {
  Button,
  Typography,
  Box,
  Rating,
  TextField,
  Chip,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import StarIcon from "@mui/icons-material/Star";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@mui/icons-material/Edit";
// import ReadMoreReact from "read-more-react";
import { Grid } from "@mui/material";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = React.useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className="text">
      {isReadMore ? text.slice(0, 150) : text}
      <span onClick={toggleReadMore} className="read-or-hide">
        {isReadMore ? "...read more" : " show less"}
      </span>
    </p>
  );
};
const labels = {
  0.5: "Useless",
  1: "Useless+",
  1.5: "Poor",
  2: "Poor+",
  2.5: "Ok",
  3: "Ok+",
  3.5: "Good",
  4: "Good+",
  4.5: "Excellent",
  5: "Excellent+",
};

function getLabelText(value) {
  return `${value} Star${value !== 1 ? "s" : ""}, ${labels[value]}`;
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

const CompletedInterview = () => {
  const [value, setValue] = React.useState(3.5);
  const [hover, setHover] = React.useState(-1);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <div className="relative w-full overflow-hidden bg-white box-shadow-request-card grid grid-cols-4 rounded-lg my-4 p-2">
        {/* Updated */}
        <div className="absolute h-full w-full unshow" id="updated">
          <div className="flex justify-center items-center h-full bg-gray-500/50">
            <div className="px-4 py-2 bg-green-500 rounded-md">
              <Typography variant="h4" component="h4" sx={{ color: "white" }}>
                Updated
              </Typography>
            </div>
          </div>
        </div>

        {/* Canceled */}
        <div className="absolute h-full w-full unshow" id="canceled">
          <div className="flex justify-center items-center h-full bg-gray-500/50">
            <div className="absolute text-2xl top-2 right-2 text-red-600 cursor-pointer hover:text-red-800">
              <i className="fa-solid fa-circle-xmark"></i>
            </div>
            <div className="px-4 py-2 bg-red-600 rounded-md">
              <Typography variant="h4" component="h4" sx={{ color: "white" }}>
                Canceled
              </Typography>
            </div>
          </div>
        </div>
        <div className="absolute bottom-1 right-2 text-right">
          <p className="text-xs text-gray-400">Sent 45 Min ago</p>
          <p className="text-xs text-gray-400">Accepted 15 Min ago</p>
        </div>
        <div className="border-r border-gray-400 my-auto col-span-1">
          <img
            src={require("../../../images/photo.png")}
            className="h-32 rounded-full border-2 border-black p-1 block mx-auto"
            alt="Profile"
          />
          <button className="view-profile-card-btn w-4/5 mt-2 mx-auto">
            View Profile
          </button>
        </div>
        <div className="px-3 col-span-3">
          <div className="flex py-1 justify-between w-full">
            <div className="w-12 h-12 logo-shadow mx-1 rounded-lg">
              <img src={require("../../../images/amazon.png")} alt="google" />
            </div>
            <div className="text-center">
              <h4 className="text-2xl font-medium leading-4">John Doe</h4>
              <p>Data Analyst, Microsoft, USA</p>
            </div>
            <div className="flex gap-2">
              <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-blue-500 text-2xl hover:text-blue-600 cursor-pointer">
                <i className="fa-solid fa-bookmark"></i>
              </div>
              <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-green-500 text-2xl hover:text-green-600 cursor-pointer">
                <i className="fa-solid fa-share"></i>
              </div>
            </div>
          </div>
          <div
            className="flex justify-between text-center my-1 gap-x-1 mx-2"
            style={{ alignItems: "flex-start" }}
          >
            <div>
              <p className="text-base text-gray-400">Profile</p>
              <Chip
                label="Data Science"
                color="info"
                sx={{ fontWeight: "medium" }}
              />
            </div>
            <div>
              <p className="text-base text-gray-400">Price</p>
              <p className="text-lg">INR 299</p>
            </div>
            <div>
              <p className="text-base text-gray-400">Session Duration</p>
              <p className="text-lg">30 Min</p>
            </div>
            <div>
              <p className="text-base text-gray-400">Interview Slot</p>
              <p className="text-lg">[12:00 PM - 12:30 PM]</p>
              <p className="text-lg">20 June, 2022</p>
            </div>
          </div>
          <div className="relative flex justify-center">
            <div className="meeting-id">Mock Interview ID: #342B14CD9</div>
            <div className="rate-btn flex">
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "red",
                }}
                onClick={handleOpen}
              >
                Rate and Review
              </Button>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Box
                    sx={{
                      position: "absolute",
                      right: 0,
                      top: 0,
                    }}
                  >
                    <IconButton onClick={handleClose}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    sx={{ textAlign: "center" }}
                  >
                    Rate and Review
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    Please Rate and Review your Interview Experience.
                  </Typography>
                  <Box
                    sx={{
                      width: 200,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Rating
                      name="hover-feedback"
                      value={value}
                      precision={0.5}
                      getLabelText={getLabelText}
                      onChange={(event, newValue) => {
                        setValue(newValue);
                      }}
                      onChangeActive={(event, newHover) => {
                        setHover(newHover);
                      }}
                      emptyIcon={
                        <StarIcon
                          style={{ opacity: 0.55 }}
                          fontSize="inherit"
                        />
                      }
                    />
                    {value !== null && (
                      <Box sx={{ ml: 2 }}>
                        {labels[hover !== -1 ? hover : value]}
                      </Box>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <TextField
                      id="outlined-multiline-static"
                      label="Review"
                      multiline
                      rows={4}
                      sx={{
                        mb: 2,
                      }}
                    />
                    <Button variant="outlined">Submit</Button>
                  </Box>
                </Box>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompletedInterview;
